// vanilla JS file - to be used with the static component
import { handleSubmitForm } from "../../NewsletterForm/src/postFields";
import {
  debounce,
  detachAndAppendElement,
  isEsports,
  getMediaDevice
} from "../../../helpers";

import { toggleMyAccount } from "../../../dynamic/MyAccount/index";

const checkNavigationWidth = () => {
  const checkValue = (
    value: Object | Element | HTMLElement | null,
    prop: string,
    fallbackValue?: number | string
  ) => (value ? value[prop] : fallbackValue ? fallbackValue : 0);

  const setTotals = (el: HTMLElement) => {
    let styles = window.getComputedStyle(el, null);
    let item = {
      el,
      totalWidth:
        el.clientWidth +
        parseFloat(checkValue(styles, "marginLeft")) +
        parseFloat(checkValue(styles, "marginRight"))
    };
    return item;
  };

  const siteLogo = document.querySelector(".site-logo__wrapper");

  const siteLogoOffset =
    checkValue(siteLogo, "offsetLeft") + checkValue(siteLogo, "clientWidth");

  const shopBtn = document.querySelector(
    ".main-nav__link--shop__wrapper > .main-nav__link--shop"
  );
  const menuWrapper = document.querySelector(
    "#site-header .main-nav nav[role=navigation]"
  );
  // @ts-ignore
  const navMenuWrapper: HTMLElement = document.querySelector(
    "ul.main-nav__links.main-nav__links--closed"
  );
  let shopButtonWrapper = document.querySelector(
    ".main-nav__link--shop__wrapper"
  );

  const menuShift = navMenuWrapper.classList.contains("shift");

  // @ts-ignore
  const menuItems: HTMLElement[] = Array.from(
    // @ts-ignore
    menuWrapper.querySelectorAll("ul.main-nav__links > li")
  ).map(setTotals);

  const wrapperComputedStyle = window.getComputedStyle(navMenuWrapper, null);

  const menuWrapperPadding =
    parseFloat(checkValue(wrapperComputedStyle, "paddingLeft")) +
    parseFloat(checkValue(wrapperComputedStyle, "paddingRight"));

  const menuTotal =
    menuItems.reduce((acc: number, obj: any) => obj.totalWidth + acc, 0) +
    menuWrapperPadding;

  const screenCutOffFirst =
    menuTotal + siteLogoOffset + checkValue(shopButtonWrapper, "clientWidth");

  const screenCutOffSecond = menuTotal + siteLogoOffset;
  const showHamburger = window.innerWidth < screenCutOffFirst;

  if (menuWrapper && !shopButtonWrapper) {
    shopButtonWrapper = document.createElement("div");
    shopButtonWrapper.className = "main-nav__link--shop__wrapper";
    shopButtonWrapper.innerHTML = `
      <a href="javascript:void(0)" class="nav-hamburger-icon hide">
        <span></span>
        <span></span>
      </a>
    `;
    menuWrapper.appendChild(shopButtonWrapper);
  }

  const btn: Element | HTMLElement | null = document.querySelector(
    ".nav-hamburger-icon"
  );
  const chevron = document.querySelector(".nav-hamburger-icon");

  const setUp = () => {
    if (menuShift) {
      navMenuWrapper.removeAttribute("style");
      navMenuWrapper.classList.remove("shift");
    }

    if (showHamburger) {
      // check condition for making m chevron toggle appear
      const hamburgerBtn = document.querySelector(".nav-hamburger-icon");
      if (shopButtonWrapper) shopButtonWrapper.classList.add("sticky");
      if (hamburgerBtn) hamburgerBtn.classList.remove("hide");

      // @ts-ignore
      const offsetLeft = menuWrapper.getAttribute("offsetLeft");

      if (!navMenuWrapper.classList.contains("shift") && chevron) {
        navMenuWrapper.removeAttribute("style");
        navMenuWrapper.classList.remove("shift");
        chevron.classList.remove("on");
      }
    } else {
      // other wise hide chevron toggle and remove nav menu style inline style object
      const hamburgerBtn = document.querySelector(".nav-hamburger-icon");

      if (hamburgerBtn) hamburgerBtn.classList.add("hide");
      if (shopBtn) shopBtn.classList.remove("sticky");

      if (shopButtonWrapper) {
        shopButtonWrapper.classList.remove("sticky");
      }
    }
  };

  // @ts-ignore
  btn.onclick = () => {
    if (navMenuWrapper) {
      const shopButtonOffset =
        window.innerWidth - checkValue(shopButtonWrapper, "clientWidth");
      const offsetLeft = shopButtonOffset - screenCutOffSecond - 10;
      if (chevron) {
        if (navMenuWrapper.style.marginLeft) {
          navMenuWrapper.removeAttribute("style");
          navMenuWrapper.classList.remove("shift");
          chevron.classList.remove("on");
        } else {
          navMenuWrapper.style.marginLeft = `${offsetLeft}px`;
          navMenuWrapper.classList.add("shift");
          chevron.classList.add("on");
        }
      }
    }
  };

  setUp();
};

export const handleHeaderScroll = () => {
  if (document && document.getElementById("site-header") !== null) {
    // the ! is needed to say, yep this is definitely not null (for some reason the above line isnt enough)
    const siteHeader: HTMLElement = document.getElementById("site-header")!;
    if (
      document.body.scrollTop > siteHeader.clientHeight ||
      document.documentElement.scrollTop > siteHeader.clientHeight
    ) {
      // make the header smaller
      siteHeader.classList.add("site-header--scrolled");
      // const body = document.getElementsByTagName("body").item(0)!;
      // body.style.marginTop = `${siteHeader.clientHeight}px`;
    } else {
      // make the header full size again
      siteHeader.classList.remove("site-header--scrolled");
      // setTimeout(() => {
      //   const body = document.getElementsByTagName("body").item(0)!;
      //   body.style.marginTop = `${siteHeader.clientHeight}px`;
      // }, 400);
    }
  }
};

export const handleHeaderClick = function(this: HTMLElement, e: Event) {
  e.preventDefault();
  this.classList.toggle("navigation-toggle--closed");
  const body: HTMLElement | null = document.querySelector("body");
  const mainNav = document.querySelector(
    "#site-header .main-nav .main-nav__links"
  );
  if (mainNav !== null && body !== null) {
    mainNav.classList.toggle("main-nav__links--closed");
    body.style.overflow = "unset";
    body.style.height = "unset";

    if (!mainNav.classList.contains("main-nav__links--closed")) {
      body.style.overflow = "hidden";
      body.style.height = "100vh";
    }
  }
};

export const setBodyMargin = () => {
  if (document && document.getElementById("site-header") !== null) {
    // the ! is needed to say, yep this is definitely not null (for some reason the above line isnt enough)
    // const siteHeader: HTMLElement = document.getElementById("site-header")!;
    const body = document.getElementsByTagName("body").item(0)!;
    // body.style.marginTop = `${siteHeader.clientHeight}px`;
    setTimeout(() => {
      body.classList.add("loaded");
    }, 300);
  }
};

export const nav = () => {
  var signUpForm = document.getElementById("sign-up-form");
  var signUpButtonMob = document.getElementById("sign-up-link-mobile");
  var successMessage = document.getElementById("sign-up-success-message");
  var signUpButton = document.getElementById("sign-up-link");
  var formHeading: HTMLElement | null = document.querySelector(
    ".newsletter-form__container h2"
  );
  var body = document.querySelector("body");
  var desctiptionText: HTMLElement | null = document.querySelector(
    ".newsletter-form__description"
  );

  document.querySelectorAll(".tennisid_nav").forEach((el: EventTarget) => {
    // @ts-ignore
    el.addEventListener("click", toggleMyAccount);
  });

  // header scroll
  window.onscroll = function() {
    handleHeaderScroll();
  };

  window.onload = function() {
    const header = document.getElementById("site-header");
    if (!header) return;
    if (isEsports()) {
      document.body.classList.add("esports");
    }
    detachAndAppendElement(".share-to-header", ".site-header");
    if (getMediaDevice(false) !== "MOBILE") {
      checkNavigationWidth();
    }
  };

  // header toggle
  if (document !== null && document.getElementById("site-header") !== null) {
    const headerToggle: HTMLElement | null = document
      .getElementById("site-header")!
      .querySelector(".navigation-toggle");
    if (headerToggle) {
      headerToggle.addEventListener("click", handleHeaderClick);
    }
  }
  // cookie banner
  if (localStorage.getItem("cookieBannerAccepted") !== "yes") {
    if (
      document !== null &&
      document.getElementById("cookie-banner") !== null
    ) {
      const cookieBanner: HTMLElement | null = document.getElementById(
        "cookie-banner"
      )!;
      const cookieCloseBtn: HTMLElement | null = document.getElementById(
        "cookie-banner-close"
      )!;
      // show the banner if it hasnt been seen
      cookieBanner.setAttribute("style", "display:block");

      // set up ability to hide the banner
      cookieCloseBtn.onclick = function(e: Event) {
        e.preventDefault();
      };
    }
  }
  // body margin
  setBodyMargin();

  function closeHandler() {
    if (
      signUpForm !== null &&
      signUpButton !== null &&
      signUpButtonMob !== null &&
      successMessage !== null &&
      formHeading !== null &&
      desctiptionText !== null &&
      body !== null
    ) {
      successMessage.innerHTML = "";
      formHeading.innerHTML = "Sign Up";
      desctiptionText.removeAttribute("style");
      signUpForm.removeAttribute("style");
      signUpForm.className = "hide";
      body.style.position = "";
      body.style.overflow = "";
      body.classList.remove("newsletter--isOpen");
      signUpButtonMob.classList.remove("close");
      signUpButton.classList.remove("close");
    }
  }

  if (document !== null) {
    const signUpButton = document.getElementById("sign-up-link");
    const signUpForm = document.getElementById("sign-up-form");
    const signUpButtonMob = document.getElementById("sign-up-link-mobile");
    const signUpClose = document.getElementById("sign-up-close");
    const body = document.querySelector("body");

    const openHandler = () => {
      if (
        signUpButton !== null &&
        signUpForm !== null &&
        signUpButtonMob !== null &&
        body !== null
      ) {
        signUpButtonMob.classList.add("close");
        signUpButton.classList.add("close");
        signUpForm.className = "show";
        body.classList.add("newsletter--isOpen");
        body.style.overflow = "hidden";
        body.style.position = "fixed";
        if (signUpForm !== null) {
          handleSubmitForm(signUpForm);
        }
      }
    };

    const signUpBtnCallback = () => {
      if (signUpForm !== null) {
        if (signUpForm.classList.contains("show")) {
          closeHandler();
        } else {
          openHandler();
        }
      }
    };

    if (signUpButton !== null) {
      signUpButton.addEventListener("click", signUpBtnCallback);
    }

    if (signUpButtonMob !== null) {
      signUpButtonMob.addEventListener("click", signUpBtnCallback);
    }

    if (
      signUpButtonMob !== null &&
      signUpClose !== null &&
      signUpForm !== null &&
      body !== null
    ) {
      signUpClose.addEventListener("click", () => {
        signUpForm.className = "hide";
        body.classList.remove("newsletter--isOpen");
        signUpButtonMob.classList.remove("active");
        body.style.overflow = "";
        body.style.position = "static";
      });
    }

    if (location.search.includes("showSignup=true")) {
      openHandler();
    }
  }

  debounce({ func: handleHeaderScroll });
  debounce({
    delay: 300,
    func: () => {
      if (getMediaDevice(false) !== "MOBILE") {
        checkNavigationWidth();
      }
    }
  });
};
